<form [formGroup]="passwordForm" class="w-100" (submit)="sendRequest()">
  @if (error$ | async; as error) {
  <atx-alert
    [severity]="severity.Error"
    [icon]="['fas', 'exclamation-triangle']"
  >
    {{ getAuthenticationError(error) }}
  </atx-alert>
  }
  <div
    class="p-3 mb-3 message-container"
    i18n-placeholder="
      AuthPage|Reset password info message@@resetPasswordPageInfoMessage"
  >
    <fa-icon [icon]="['fas', 'circle-info']" class="mr-1"></fa-icon> The
    password must be at least 12 characters long and must contain at least one
    uppercase letter, one lowercase letter, one numerical digit, and one special
    character.
  </div>
  <div class="form-group flex-wrap">
    <div class="form-group mb-0" [ngClass]="getValidityClass('newPassword')">
      <fa-icon [icon]="['fas', 'lock']" class="input-icon"></fa-icon>
      <input
        type="password"
        class="form-control"
        id="username-input"
        formControlName="newPassword"
        placeholder="Password"
        i18n-placeholder="
          AuthPage|New password
          placeholder@@resetPasswordPageNewPasswordPlaceholder"
      />
    </div>
    @if (getInputErrorMessages('newPassword').length > 0) {
    <div class="invalid-feedback mt-1">
      <atx-alert
        class="align-items-start"
        [severity]="severity.Error"
        [icon]="['fas', 'exclamation-triangle']"
      >
        <ul class="pl-3 m-0">
          @for (error of getInputErrorMessages('newPassword'); track error) {
          <li>{{ error }}</li>
          }
        </ul>
      </atx-alert>
    </div>
    }
  </div>

  <div class="form-group flex-wrap">
    <div
      class="form-group mb-0"
      [ngClass]="getValidityClass('confirmPassword')"
    >
      <fa-icon [icon]="['fas', 'check']" class="input-icon"></fa-icon>
      <input
        type="password"
        class="form-control"
        id="username-input"
        formControlName="confirmPassword"
        placeholder="Confirm"
        i18n-placeholder="
          AuthPage|Confirm new password
          placeholder@@resetPasswordPageConfirmNewPasswordPlaceholder"
      />
    </div>

    @if (getInputErrorMessages('confirmPassword').length > 0) {
    <div class="invalid-feedback mt-1">
      <atx-alert
        class="align-items-start"
        [severity]="severity.Error"
        [icon]="['fas', 'exclamation-triangle']"
      >
        <ul class="pl-3 m-0">
          @for (error of getInputErrorMessages('confirmPassword'); track error)
          {
          <li>{{ error }}</li>
          }
        </ul>
      </atx-alert>
    </div>
    }
  </div>

  <button
    type="submit"
    class="btn btn-primary w-100 d-flex align-items-center justify-content-center text-uppercase send-request-btn"
    [disabled]="passwordForm.invalid"
    i18n="
      AuthPage|Reset password button value@@resetPasswordPageResetRequestButton"
  >
    <fa-icon [icon]="['fas', 'paper-plane']" size="xs" class="mr-2"></fa-icon>
    Reset password
  </button>
</form>
